import { render, staticRenderFns } from "./VCarousel.vue?vue&type=template&id=3adfbeee&scoped=true"
import script from "./VCarousel.vue?vue&type=script&lang=ts"
export * from "./VCarousel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adfbeee",
  null
  
)

export default component.exports